import { DOCMembersListFilters } from '../../../styledComponents/ProductMembersList/DOCMembersList/DOCMembersFilters/docMembersFilters.models';

export const docPageFilters = [
  DOCMembersListFilters.Search,
  DOCMembersListFilters.Package,
  DOCMembersListFilters.RenewStatus,
];
